<template>
  <a
    :href="props.href"
    class="px-3 py-1.5 rounded-lg text-sm/6 font-semibold inline-flex gap-2 items-center justify-center transition-colors cursor-pointer"
    :class="variants[props.variant ?? 'primary']"
  >
    <slot></slot>
  </a>
</template>
<script setup lang="ts">
type Variant = "primary" | "ghost";

const props = defineProps<{
  href?: string;
  variant?: Variant;
}>();

const variants: Record<Variant, string> = {
  primary: "bg-purple-600 text-white hover:bg-purple-800 focus:bg-purple-700",
  ghost: "hover:bg-gray-800/10 focus:bg-gray-800/10",
};
</script>
